<template>
    <div class="field is-horizontal">
        <div class="field-label is-normal">
            <label class="label">User Type</label>
        </div>
        <div class="field-body">
            <div class="field">
                <div class="control has-icons-left">
                    <div class="select is-fullwidth" v-model="user_type" :class="{ 'is-danger': errors.user_type }">
                        <select v-model="user_type">
                            <option value="" selected disabled>Select Type</option>
                            <option :value="this.$userTypeIndividual">Individual</option>
                            <option :value="this.$userTypeProfessional">Professional</option>
                            <option :value="this.$userTypeOther">Other</option>
                        </select>
                    </div>
                    <span class="icon is-left">
                        <i class="fas fa-users"></i>
                    </span>
                    <p v-if="errors.user_type" class="help is-danger">{{ errors.user_type[0] }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {

            }
        },
        computed: {
            user_type: {
                get() {
                    return this.$store.getters.getNewPricePlan.user_type
                },
                set(value) {
                    this.$store.dispatch('setNewPricePlanFieldValue', {field: 'user_type', value: value})
                }
            },
            errors() {
                return this.$store.getters.getNewPricePlanErrors
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/ControlPanel/PricePlans/NewPlan/Inputs/UserTypeSelect.vue